import { Component, Input } from "@angular/core";
import { AlertController, LoadingController, Loading, ToastController } from 'ionic-angular';
import { AngularFirestore, AngularFirestoreCollection } from "angularfire2/firestore";
import { Subscription } from "rxjs/Subscription";

interface Child {
  "desc": string;
  "link": string;
  "name": string;
  "new": boolean;
  "order": number;
  "id": string;
}

interface Parent {
  "order": number;
  "id": string;
  "name": string;
  "canReorder": boolean;
  "collapsed": boolean;
  "items": Child[];
}

@Component({
  selector: "downloads",
  templateUrl: "downloads.html"
})

export class DownloadsComponent {
  @Input() usertype: String;
  loading: Loading;
  canReorder: boolean = false;
  someoneisReordering: boolean = false;
  parentCollection: AngularFirestoreCollection<Parent>;
  parentItems: Parent[];
  subscriptions: Subscription;

  constructor(private toastCtrl: ToastController, private loadingCtrl: LoadingController, private asf: AngularFirestore, private alertCtrl: AlertController) {
    this.init();
  }

  init() {
    this.parentCollection = this.asf.collection("Uploads", ref => ref.orderBy("order", "asc"));
    this.subscriptions = this.parentCollection.snapshotChanges().subscribe(collection => {
      this.parentItems = [];
      collection.forEach((element) => {
        const data = element.payload.doc.data() as Parent;
        const id = element.payload.doc.id;
        element.payload.doc.ref.collection("files").orderBy("order", "asc").onSnapshot(docs => {
          const index = this.parentItems.map(ele => { return ele.id }).indexOf(id);
          this.parentItems[index].items = [];
          if (index > -1) {
            this.parentItems[index].items = docs.docs.map(ele => {
              const data = ele.data() as Child;
              const id = ele.id;
              return { id, ...data }
            });
          }
        });
        const dataToPush = {
          "id": id,
          "canReorder": data.canReorder,
          "collapsed": data.collapsed,
          "items": [],
          "name": data.name,
          "order": data.order
        }
        this.parentItems.push(dataToPush);
      });
    });
  }

  reorderItems(indexes: any) {
    if (this.canReorder) {
      let batch = this.asf.firestore.batch();
      let element = this.parentItems[indexes.from];
      this.parentItems.splice(indexes.from, 1);
      this.parentItems.splice(indexes.to, 0, element);
      this.parentItems.forEach((item, index: number) => {
        if (item.order != index) {
          let ref = this.asf.doc('Uploads/' + item.id).ref;
          batch.update(ref, { order: index });
        }
      })
      batch.commit().then(() => {
        this.presentToast('Se ordenó lista');
      }).catch(error => {
        this.presentToast('Ha ocurrido un error');
      })
    }
  }

  reorderItems2(indexes: any, id: string, index: number) {
    let batch = this.asf.firestore.batch();
    let element = this.parentItems[index].items[indexes.from];
    this.parentItems[index].items.splice(indexes.from, 1);
    this.parentItems[index].items.splice(indexes.to, 0, element);
    this.parentItems[index].items.forEach((item, index: number) => {
      if (item.order != index) {
        let ref = this.asf.doc('Uploads/' + id + '/files/' + item.id).ref;
        batch.update(ref, { order: index });
      }
    })
    batch.commit().then(() => {
      this.presentToast('Se ordenó lista');
    }).catch(() => {
      this.presentToast('Ha ocurrido un error');
    })
  }

  canReorderM() {
    this.canReorder = !this.canReorder;
    this.parentItems.forEach(element => {
      element.collapsed = true;
    });
  }

  someoneisReorderingF() {
    if (this.parentItems.map(ele => { return ele.canReorder }).indexOf(true) > -1) {
      this.someoneisReordering = true;
    } else {
      this.someoneisReordering = false;
    }
  }

  changeNew(y, x, event) {
    this.presentLoadingCustom();
    this.asf.doc("Uploads/" + x + "/files/" + y.id).update({ "new": Boolean(event.value) }).then(() => {
      this.loading.dismiss();
      this.presentToast('Actualizado correctamente');
    }).catch(() => {
      this.loading.dismiss();
      this.presentToast("¡Ha ocurrido un error!");
    });
  }

  presentPrompt(data, docId) {
    let alert = this.alertCtrl.create({
      title: 'Editar archivo',
      inputs: [
        {
          name: 'name',
          placeholder: 'Nombre del archivo',
          value: data.name
        },
        {
          name: 'desc',
          placeholder: 'Descripción',
          value: data.desc
        },
        {
          name: 'link',
          placeholder: 'Link Google Drive',
          value: data.link
        }
      ],
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Guardar',
          handler: dataToSave => {
            if (dataToSave && dataToSave.name && dataToSave.desc && dataToSave.link && dataToSave.link != '' && dataToSave.desc != '' && dataToSave.name != '') {
              this.presentLoadingCustom();
              this.asf.doc("Uploads/" + docId + "/files/" + data.id).update(dataToSave).then(() => {
                this.loading.dismiss();
                this.presentToast('Actualizado correctamente');
              }).catch(() => {
                this.loading.dismiss();
                this.presentToast("¡Ha ocurrido un error!");
              });
            } else {
              this.presentToast("¡Campos vacíos!");
              return false;
            }
          }
        }
      ]
    });
    alert.present();
  }

  presentConfirm(idParent, id) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar elemento',
      message: '¿Estas seguro de eliminar este elemento?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.delete(idParent, id);
          }
        }
      ]
    });
    alert.present();
  }

  presentConfirm2(id) {
    let alert = this.alertCtrl.create({
      title: 'Eliminar elemento',
      message: '¿Estas seguro de eliminar este elemento?',
      buttons: [
        {
          text: 'Cancelar',
          role: 'cancel'
        },
        {
          text: 'Eliminar',
          handler: () => {
            this.delete2(id);
          }
        }
      ]
    });
    alert.present();
  }

  delete(idParent, id) {
    this.asf.doc<any>('Uploads/' + idParent + '/files/' + id).delete();
  }

  delete2(id) {
    this.asf.doc<any>('Uploads/' + id).delete();
  }

  presentLoadingCustom() {
    this.loading = this.loadingCtrl.create({
      content: `Loading`
    });
    this.loading.present();
  }

  presentToast(message) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000
    });
    toast.present();
  }

  showPrompt(id: string, name: string) {
    const prompt = this.alertCtrl.create({
      title: 'Agregar categoría',
      inputs: [
        {
          name: 'name',
          placeholder: 'Categoría',
          value: name
        },
      ],
      buttons: [
        {
          text: 'Cancelar'
        },
        {
          text: 'Guardar',
          handler: data => {
            if (data && data.name) {
              this.presentLoadingCustom();
              this.asf.doc("Uploads/" + id).update({ "name": data.name }).then(() => {
                this.loading.dismiss();
                this.presentToast('Actualizado correctamente');
              }).catch(() => {
                this.loading.dismiss();
                this.presentToast("¡Ha ocurrido un error!");
              });
            } else {
              this.presentToast("¡Campo vacío!");
            }
          }
        }
      ]
    });
    prompt.present();
  }

}



// WEBPACK FOOTER //
// ./src/components/downloads/downloads.ts